import { render } from "./RequestCart.vue?vue&type=template&id=60dbf402"
import script from "./RequestCart.vue?vue&type=script&lang=js"
export * from "./RequestCart.vue?vue&type=script&lang=js"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__